/**
 * 안전 안내 카드 (DEV_SPEC 4.9, DESIGN_SPEC 6장). 상회게시판·고민·1:1 어디서든 같은 카드입니다.
 *
 * 경고색이 아닌 차분한 청록(--color-safety). 닫을 수 있고, 닫으면 「도움받을 곳 다시 보기」
 * 알약으로 남습니다. L3(급박)면 119 를 맨 위에 둡니다.
 */
import { useEffect } from 'react';
import { Heart } from 'lucide-react';
import { pathKey, track } from '../api/track.js';

export function SafetyCard({ level = 'L2', collapsed, onCollapse, onExpand }) {
    // 위기 이벤트 대비 안내 노출 (명세 v1.3 10장, D44). 카드가 처음 그려질 때 한 번
    useEffect(() => {
        track('safety_card_shown', { level, path: pathKey() });
    }, [level]);
    if (collapsed) {
        return (
            <button
                type="button"
                onClick={onExpand}
                className="flex h-9 items-center gap-1.5 self-start rounded-[18px] bg-safety-tint px-3 text-[13px] font-semibold text-safety"
            >
                <Heart size={16} strokeWidth={1.6} aria-hidden="true" />
                도움받을 곳 다시 보기
            </button>
        );
    }

    return (
        <section aria-label="도움받을 곳" className="flex flex-col gap-3 rounded-card bg-safety-tint p-4">
            <div className="flex items-start gap-2.5">
                <Heart size={22} strokeWidth={1.6} aria-hidden="true" className="mt-0.5 shrink-0 text-safety" />
                <p className="m-0 text-body">
                    지금 많이 힘들다면 바로 이야기 나눌 수 있는 곳이 있어요. 전화하면 지금 사람이 받아요.
                </p>
            </div>
            {level === 'L3' ? (
                <a
                    href="tel:119"
                    onClick={() => track('safety_call_tap', { number: '119' })}
                    className="flex h-11 items-center justify-center rounded-[10px] bg-safety text-[15px] font-semibold text-on-brand no-underline"
                >
                    지금 위험하다면 119
                </a>
            ) : null}
            <a
                href="tel:109"
                onClick={() => track('safety_call_tap', { number: '109' })}
                className={`flex h-11 items-center justify-center rounded-[10px] text-[15px] font-semibold no-underline ${
                    level === 'L3' ? 'border border-safety text-safety' : 'bg-safety text-on-brand'
                }`}
            >
                자살예방상담전화 109
            </a>
            <a
                href="tel:15770199"
                onClick={() => track('safety_call_tap', { number: '15770199' })}
                className="flex h-11 items-center justify-center rounded-[10px] border border-safety text-[15px] font-semibold text-safety no-underline"
            >
                정신건강위기상담 1577-0199
            </a>
            <button type="button" onClick={onCollapse} className="h-9 self-center px-3 text-[13px] text-text-secondary">
                닫기
            </button>
        </section>
    );
}
